import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getUserEmail, getUserName, clearSession, getLogoutURL, isOrgAdmin, isSuperAdmin, isDemoMode, setDemoMode, getStoredToken } from '../auth/cognito';

const API_URL = 'https://0emko5cw6f.execute-api.ca-central-1.amazonaws.com/prod';

export default function Nav() {
  const email = getUserEmail();
  const name = getUserName();
  const initials = (name || email)[0]?.toUpperCase() || '?';
  const orgAdmin = isOrgAdmin();
  const superAdmin = isSuperAdmin();
  const [demo, setDemo] = useState(isDemoMode());

  function toggleDemo() {
    const next = !demo;
    setDemoMode(next);
    setDemo(next);
    window.location.reload(); // re-fetch plan state from Dashboard
  }

  async function logout() {
    const token = getStoredToken();
    if (token) {
      try {
        await fetch(`${API_URL}/auth/logout`, { method: 'POST', headers: { Authorization: token } });
      } catch { /* proceed with local logout even if server revocation fails */ }
    }
    clearSession();
    window.location.href = getLogoutURL();
  }

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      padding: '14px 24px', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between',
      background: 'rgba(5,13,31,0.85)', backdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(255,255,255,0.06)'
    }}>
      <a href="/" style={{ fontSize: 16, fontWeight: 700, color: '#fff', textDecoration: 'none' }}>
        privacy<span style={{ color: '#818cf8' }}>.education</span>
      </a>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        {superAdmin && (
          <button
            onClick={toggleDemo}
            title={demo ? 'Demo mode on — all modules unlocked. Click to turn off.' : 'Turn on demo mode to unlock all modules'}
            style={{
              fontSize: 12, fontWeight: 700, cursor: 'pointer',
              padding: '4px 12px', borderRadius: 6, border: 'none',
              background: demo ? '#f59e0b' : 'rgba(255,255,255,0.08)',
              color: demo ? '#1c1917' : 'rgba(255,255,255,0.4)',
              transition: 'all 0.15s',
            }}
          >
            {demo ? 'Demo ON' : 'Demo'}
          </button>
        )}
        {orgAdmin && (
          <a href="/team" style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontWeight: 500 }}>
            Team
          </a>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 32, height: 32, borderRadius: '50%',
            background: 'linear-gradient(135deg,#6366f1,#a855f7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 13, fontWeight: 700, color: '#fff'
          }}>{initials}</div>
          <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>{email}</span>
        </div>
        <button onClick={logout} style={{
          background: 'rgba(255,255,255,0.06)',
          border: '1px solid rgba(255,255,255,0.12)',
          color: 'rgba(255,255,255,0.6)', padding: '6px 14px',
          borderRadius: 8, fontSize: 12, cursor: 'pointer'
        }}>Sign out</button>
        <Link to="/privacy" style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)', textDecoration: 'none' }}>Privacy</Link>
      </div>
    </nav>
  );
}